import {utils} from '@wallaby-ui/core';
import {isArray, includes, isObject, forEach, every} from 'lodash';

import {constants} from 'src/js/common';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

const logger = utils.LogUtils.getLogger(
  'AutoLayoutUtils',
  constants.LIBRARY_NAME
);

const AutoLayoutUtils = {
  // TODO change key to path to data
  getDataVal(data, key) {
    const inputData = data.content || data;
    let dataVal = inputData[key]
      ? inputData[key][KEYWORD_PROP_CONTENT_VALUE]
      : null;
    if (isObject(dataVal) && 'id' in dataVal) {
      dataVal = dataVal.id;
    }
    return dataVal;
  },

  isValueInList(valuesList, data) {
    if (data && data[KEYWORD_PROP_CONTENT_VALUE] && isArray(valuesList)) {
      const value =
        data[KEYWORD_PROP_CONTENT_VALUE].id || data[KEYWORD_PROP_CONTENT_VALUE];
      if (includes(valuesList, value)) {
        return true;
      }
    }
    return false;
  },

  checkDataConditions(conditions, data) {
    if (isArray(conditions)) {
      let checkConditions = true;
      // eslint-disable-next-line consistent-return
      forEach(conditions, (condition) => {
        const condDataVal = AutoLayoutUtils.getDataVal(
          data,
          condition.property
        );
        const condDataConstraint = condition.value;
        switch (condition.condition) {
          case 'IS': {
            checkConditions = condDataVal === condDataConstraint;
            break;
          }
          case 'IS NOT': {
            checkConditions = condDataVal !== condDataConstraint;
            break;
          }
        }
        if (!checkConditions) {
          return false;
        }
      });
      return checkConditions;
    }
    logger.error(`Invalid conditions configuration: ${conditions}`);
    return false;
  },

  checkArrayDataConditions(type, arrayConditions, arrayData, checkData) {
    if (isArray(arrayConditions)) {
      let lastTrueConditionIndex = -1;
      // eslint-disable-next-line consistent-return
      forEach(arrayData, (screenData, idx) => {
        let checkCondition = true;
        // eslint-disable-next-line consistent-return
        forEach(arrayConditions, (condition) => {
          const condDataVal = AutoLayoutUtils.getDataVal(
            screenData,
            condition.arrayItemScreenProperty
          );
          switch (condition.condition) {
            case 'IS_EQUAL': {
              const checkDataVal = AutoLayoutUtils.getDataVal(
                checkData,
                condition.property
              );
              checkCondition = condDataVal === checkDataVal;
              break;
            }
            case 'IS_NOT_EQUAL': {
              const checkDataVal = AutoLayoutUtils.getDataVal(
                checkData,
                condition.property
              );
              checkCondition = condDataVal !== checkDataVal;
              break;
            }
            case 'IS': {
              checkCondition = condDataVal === condition.value;
              break;
            }
            case 'IS NOT': {
              checkCondition = condDataVal !== condition.value;
              break;
            }
          }
          if (!checkCondition) {
            return false;
          }
        });
        if (checkCondition) {
          lastTrueConditionIndex = idx;
        }
      });
      switch (type) {
        case 'EXISTS': {
          return lastTrueConditionIndex > -1;
        }
        case 'ALL': {
          return lastTrueConditionIndex === arrayData.length - 1;
        }
        case 'ANY': {
          return lastTrueConditionIndex === -1;
        }
        default: {
          logger.error(`Invalid array condition type configuration: ${type}`);
          return false;
        }
      }
    }
    logger.error(`Invalid array conditions configuration: ${arrayConditions}`);
    return false;
  },

  isPropertyArray(metadata, propertyName) {
    // TODO: working only on the first level, change propertyName to path to data
    //  Note: current HAI definition of autolayout does not contain nested array data
    const contentPropertyInfo = metadata
      .getItemContent()
      .getPropertyByPathToData(propertyName, metadata.getContent());
    return contentPropertyInfo.isArray;
  },

  removeEmptyArrayItems(data, metadata, propertyName) {
    const resultData = data;
    if (AutoLayoutUtils.isPropertyArray(metadata, propertyName)) {
      let arrayValue = data.content[propertyName];
      if (arrayValue?.length > 0) {
        arrayValue = arrayValue.filter((item) => {
          const isEmptyItem = every(item, (mapItem, mapItemKey) => {
            return AutoLayoutUtils.getDataVal(item, mapItemKey) == null;
          });
          return !isEmptyItem;
        });
        resultData.content[propertyName] = arrayValue;
      }
    }
    return resultData;
  },
};

export default AutoLayoutUtils;
